module.exports = __webpack_public_path__ + "img/hero3.c1e27902.jpg";